import { useDrawerFooter } from '@zorro/design-system/v2/Drawer';

import { FormFooter } from '../../../FormFooter';
import { LogEnrollmentCallFormInputs } from './LogEnrollmentCallFormInputs';
import { useLogEnrollmentCallForm } from './useLogEnrollmentCallForm';

export interface LogEnrollmentCallFormProps {
  onboardingPeriodId: string;
  onClose: () => void;
}

export const LogEnrollmentCallForm = ({
  onboardingPeriodId,
  onClose,
}: LogEnrollmentCallFormProps) => {
  const { logEnrollmentCallForm, onSubmit, actorRole } =
    useLogEnrollmentCallForm({
      onboardingPeriodId,
      onClose,
    });
  const { isValid } = logEnrollmentCallForm.formState;

  useDrawerFooter(
    <FormFooter
      withPaper={false}
      primaryLabel="Save"
      primaryButtonProps={{
        onClick: onSubmit,
        disabled: !isValid,
      }}
      secondaryLabel="Cancel"
      secondaryButtonProps={{
        onClick: onClose,
        variant: 'tertiary',
      }}
    />
  );

  return (
    <form onSubmit={onSubmit}>
      <LogEnrollmentCallFormInputs
        logEnrollmentCallForm={logEnrollmentCallForm}
        onboardingPeriodId={onboardingPeriodId}
        actorRole={actorRole}
      />
    </form>
  );
};
